import { LocalizationProvider } from '@mui/x-date-pickers'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import CssBaseline from '@mui/material/CssBaseline'
import { StyledEngineProvider } from '@mui/material/styles'
import jaLocale from 'date-fns/locale/ja'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { store } from './app/store'
import './index.scss'
import './quill.snow.scss'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <BrowserRouter>
          <CssBaseline />
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={jaLocale}
          >
            <Suspense fallback={<div>Loading...</div>}>
              <App />
            </Suspense>
          </LocalizationProvider>
        </BrowserRouter>
      </Provider>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

reportWebVitals()
